<div class="parent">
  <div mat-dialog-title>
    <mode-dialog-header>
      <h1 heading>Use a Dataset</h1>
    </mode-dialog-header>
  </div>
  <nav mat-tab-nav-bar class="tabs">
    <a
      mat-tab-link
      [attr.data-test]="tab + '-tab'"
      *ngFor="let tab of tabs; trackBy: tabTrackByFn"
      [active]="selectedTab === tab"
      (click)="setTab(tab)"
    >
      {{ getTabName(tab) }}
    </a>
  </nav>

  <ng-container *ngIf="selectedTab === datasetTabType.Workspace">
    <mode-dataset-search-tab-content
      [datasetTabType]="datasetTabType.Workspace"
      [dataSourceTabContent]="workspace"
      (searchTermChange)="filterResults($event)"
      (changeCurrentPage)="handleChangeCurrentPage($event)"
      (selectDataset)="selectDataset($event)"
    ></mode-dataset-search-tab-content>
  </ng-container>

  <ng-container *ngIf="selectedTab === datasetTabType.Personal && enableDatasetsPagination">
    <mode-dataset-search-tab-content
      [datasetTabType]="datasetTabType.Personal"
      [dataSourceTabContent]="personal"
      (searchTermChange)="filterResults($event)"
      (changeCurrentPage)="handleChangeCurrentPage($event)"
      (selectDataset)="selectDataset($event)"
    ></mode-dataset-search-tab-content>
  </ng-container>

  <div class="content-container" *ngIf="selectedTab === datasetTabType.Personal && !enableDatasetsPagination">
    <div class="input-form" (keyup.enter)="onEnter()">
      <mat-form-field [hideRequiredMarker]="true" floatLabel="never">
        <input
          [class]="{ 'error-highlight': true }"
          matInput
          capraAutofocus
          autocomplete="off"
          [formControl]="datasetUrlControl"
          aria-label="import dataset url input"
          data-test="dataset-url-input"
        />
        <mat-placeholder>{{ inputPlaceholder }}</mat-placeholder>
        <capra-icon matSuffix class="input-search-icon" icon="icon-search"></capra-icon>
      </mat-form-field>
      <div class="error-container">
        <div
          class="error-message-bad-url"
          *ngIf="
            datasetUrlControl.value.length &&
            (errorMessage === IMPORT_DATASET_STATUS.BadUrl || datasetUrlControl.errors?.pattern)
          "
        >
          Please enter a valid Dataset URL, like https://app.mode.com/org/datasets/123
        </div>
        <div
          class="error-message-already-imported"
          *ngIf="datasetUrlControl.value.length && errorMessage === IMPORT_DATASET_STATUS.AlreadyImported"
        >
          This Dataset has already been added to the Report
        </div>
        <div
          class="error-message-not-found"
          *ngIf="
            datasetUrlControl.value.length &&
            (errorMessage === IMPORT_DATASET_STATUS.QueryNotFound ||
              errorMessage === IMPORT_DATASET_STATUS.DatasetNotFound)
          "
        >
          This Dataset can't be used. This usually happens when you don't have access to the Dataset's underlying
          connection, or when a Dataset is deleted
        </div>
        <div
          class="error-message-unknown"
          *ngIf="datasetUrlControl.value.length && errorMessage === IMPORT_DATASET_STATUS.Unknown"
        >
          An unknown error occurred
        </div>
      </div>
    </div>
    <capra-icon class="paste-url" width="72px" height="72px" icon="illo-dataset-url">
      <h3>To get started, paste a Dataset URL above</h3>
    </capra-icon>
  </div>
  <mode-status-banner
    class="data-persist-msg dataset-banner banner-container"
    *ngIf="
      selectedTab === datasetTabType.Personal &&
      (datasetsFacade.personalDatasetBrowserData$ | async)?.length > 0 &&
      enableDatasetsPagination
    "
    status="info"
    show-icon="true"
    layout="full-width"
  >
    <span class="banner-note"
      >Personal Datasets aren’t discoverable by other members. To make the data searchable, move it to a Workspace
      Collection</span
    >
  </mode-status-banner>
  <div mat-dialog-actions>
    <capra-button
      class="action-buttons"
      text="Cancel"
      variant="secondary"
      color="neutral"
      (clicked)="closeDialog()"
      data-test="cancel-button"
    ></capra-button>
    <capra-button-link
      *ngIf="selectedTab === datasetTabType.Workspace || enableDatasetsPagination"
      class="action-buttons link-button"
      capraTooltip
      tooltipPlacement="top"
      [tooltipContent]="toolTipHTML"
      [tooltipContentIsHtml]="true"
      [tooltipIsDisabled]="!isSampleDataset"
      [tooltipSize]="'regular'"
      [disabled]="!selectedDataset || isSampleDataset"
      icon="icon-new-tab"
      variant="secondary"
      color="neutral"
      text="Preview"
      [href]="'/' + accountId + '/datasets/' + selectedDataset?.datasetToken"
      data-test="preview-dataset-button"
    ></capra-button-link>
    <capra-button
      *ngIf="selectedTab === datasetTabType.Workspace || enableDatasetsPagination"
      [disabled]="!selectedDataset"
      text="Use Dataset"
      (clicked)="importDatasetFromSearch(selectedDataset)"
      data-test="use-dataset-button"
    ></capra-button>
    <!-- Remove this after Production flag on -->
    <capra-button
      *ngIf="selectedTab === datasetTabType.Personal && !enableDatasetsPagination"
      class="action-buttons"
      [disabled]="!datasetUrlControl.value.length || datasetUrlControl.errors"
      text="Use Dataset"
      (clicked)="importDatasetFromUrl(datasetUrlControl.value)"
      data-test="use-dataset-button"
    ></capra-button>
  </div>
</div>
